import React from 'react';
import { FunctionField } from 'react-admin';
import inflection from 'inflection';
import EnumSelectInput from 'components/Enum/EnumSelectInput';
import useCheckAccess from 'hooks/useCheckAccess';

export const normalizeJobReleaseCategories = (
  value?: string[] | null,
): string[] => value ?? [];

export const withNormalizedJobReleaseCategories = <T extends Record<string, unknown>>(
  record: T | undefined | null,
) => ({
  ...(record ?? {}),
  job_release_categories: normalizeJobReleaseCategories(
    (record as { job_release_categories?: string[] | null } | undefined | null)
      ?.job_release_categories,
  ),
});

const JobReleaseCategoriesInput = (props: Record<string, unknown>) => (
  <EnumSelectInput
    label="Job Release Categories"
    source="job_release_categories"
    multiple
    emptyText=""
    format={normalizeJobReleaseCategories}
    parse={normalizeJobReleaseCategories}
    {...props}
  />
);

export const JobReleaseCategoriesEditInput = () => {
  const checkAccess = useCheckAccess();

  if (!checkAccess('update', 'Company', 'job_release_categories')) {
    return null;
  }

  return <JobReleaseCategoriesInput />;
};

export const JobReleaseCategoriesShowField = () => {
  const checkAccess = useCheckAccess();

  if (!checkAccess('view', 'Company', 'job_release_categories')) {
    return null;
  }

  return (
    <FunctionField
      label="Job Release Categories"
      source="job_release_categories"
      render={(record: { job_release_categories?: string[] | null }) =>
        normalizeJobReleaseCategories(record?.job_release_categories)
          .map((category) => inflection.humanize(category))
          .join(', ')
      }
    />
  );
};

export default JobReleaseCategoriesInput;
